import { HttpErrorResponse } from '@angular/common/http';
import { WritableSignal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, take } from 'rxjs';

import { HttpStatusCode } from '@models';
import { handleHttpError } from './handle-http-error';

export interface ModalRequest<T> {
  request: () => Observable<T>;
  isSubmitting: WritableSignal<boolean>;
  activeModal: NgbActiveModal;
  showError: (message: string) => void;
  onSuccess: (response: T) => void;
}

export const runModalRequest = <T>({
  request,
  isSubmitting,
  activeModal,
  showError,
  onSuccess,
}: ModalRequest<T>) => {
  if (isSubmitting()) {
    return;
  }

  isSubmitting.set(true);

  request()
    .pipe(take(1))
    .subscribe({
      next: onSuccess,
      error: (error: HttpErrorResponse) =>
        handleHttpError(error, ({ message, status }) => {
          isSubmitting.set(false);
          showError(message);

          if (status === HttpStatusCode.CONFLICT) {
            activeModal.dismiss();
          }
        }),
    });
};
